import React, { useEffect, useRef, useContext, useState } from "react"

import styles from './Home.module.css'

//Components
import HeaderHome from "../../components/HeaderHome"
import Modal from "../../components/Modals/Modal"

//Actions
import * as GeneralActions from '../../store/actions/generalActions'

//Context
import GeneralContext from "../../context/GeneralContext"

import * as GeneralRepository from "../../services/repositories/general-repository";
import * as ProspectoRepository from "../../services/repositories/prospecto-repository";

//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'

const Home = ({ history }) => {
  const initialState = {
    usuario: null,
    errorCargando: null,
    listaProspectos: [],
    estaCargandoProspectos: true,
    nombre: '',
    listaProspectosSelected: [],
    verProspectosSelected: false,
    prospecto: null,
    errorSeleccionandoProspecto: false,
    estaCargandoMaestro: true,
    estaCargandoFaltante: true
  }

  const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
  let usuario = generalState.users.filter(user => user.isAuthenticated)[0]

  const [state, setState] = useState(initialState)
  const [mostrarModal, setModal] = useState(false)
  const [textos, setTextos] = useState('')
  const nombreRef = useRef()

  const handleChange = (event) => {

    //Set first letter to uppercase while typing
    nombreRef.current.value = event.target.value

    if (event.target.value.length > 2) {
      let prospectosFilter = state.listaProspectos.filter(prospecto => prospecto.nombreCompleto.toUpperCase().indexOf(event.target.value.toUpperCase()) >= 0)
      setState({
        ...state,
        nombre: event.target.value,
        verProspectosSelected: true,
        listaProspectosSelected: prospectosFilter,
        errorSeleccionandoProspecto: false
      })
    } else {
      setState({
        ...state,
        nombre: '',
        verProspectosSelected: false,
        listaProspectosSelected: [],
        errorSeleccionandoProspecto: false
      })
    }
  }

  const handleProspectoClick = async (prospecto) => {
    generalDispatch(GeneralActions.updateEstadoCargando(true))
    const response = await ProspectoRepository.mostrarMensajeProspecto(usuario !== null && usuario.info.CodigoIntermediario, prospecto.idProspecto)
    if(response.error === null) {
      if (response.mensaje.length === 0) {
        setState({
          ...state,
          nombre: prospecto.nombreCompleto,
          prospecto: prospecto,
          verProspectosSelected: false,
          errorSeleccionandoProspecto: false
        })
        nombreRef.current.value = prospecto.nombreCompleto + ' (IDProspecto: ' + prospecto.idProspecto + ')'
      } else {
        if (response.mensaje.length === 1) {
          generalDispatch(GeneralActions.updateError({ mensajeRespuesta: response.mensaje[0].message }, '¡Alerta!'))

          setState({
            ...state,
            nombre: response.mensaje[0].flag === 1 ? '' : prospecto.nombreCompleto,
            verProspectosSelected: false,
            errorSeleccionandoProspecto: false
          })
          nombreRef.current.value = response.mensaje[0].flag === 1 ? '' : prospecto.nombreCompleto + ' (IDProspecto: ' + prospecto.idProspecto + ')'
        } else {
          let textoJunto = response.mensaje.map(msj => {
            return msj.message
          })
          let flags = response.mensaje.some(fl => fl.flag === 1)

          setTextos([
            '¡Alerta!', textoJunto.join("\r\n")
          ])
          setModal(true)

          setState({
            ...state,
            nombre: flags ? '' : prospecto.nombreCompleto,
            verProspectosSelected: false,
            errorSeleccionandoProspecto: false
          })
          nombreRef.current.value = flags ? '' : prospecto.nombreCompleto + ' (IDProspecto: ' + prospecto.idProspecto + ')'
        }
      }
      generalDispatch(GeneralActions.updateEstadoCargando(false))
    } else {
      generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
    }
  }

  const handleProspectoSubmit = (event) => {
    event.preventDefault()
    if (!state.verProspectosSelected && state.nombre !== null && state.nombre.trim() !== '') {
      generalDispatch(GeneralActions.setDataProspecto(state.prospecto))
      history.push('/resumenADN');
    } else {
      setState((state) => {
        return {
          ...state,
          errorSeleccionandoProspecto: true
        }
      })
    }
  }

  const cargarDatosIniciales = async () => {
    const obtenerDatosMaestros = async () => {
      const response = await GeneralRepository.obtenerTablasMaestras()
      if(response.error === null) {
        generalDispatch(GeneralActions.setTablasMaestras(response.tablasMaestras))
        await obtenerTablaMaestraParentesco()
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
      }
    }

    const obtenerTablaMaestraParentesco = async () => {
      const response = await GeneralRepository.obtenerTablaMaestraCodigo(36)
      if(response.error === null) {
        generalDispatch(GeneralActions.agregarTablaMaestra(36, 'Parentescos', response.tablaMaestra))
        await obtenerListaProspectos()
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
      }
    }

    const obtenerListaProspectos = async () => {
      const response = await ProspectoRepository.listarProspectos(usuario !== null && usuario.info.CodigoIntermediario)
      if(response.error === null) {
        let listaProspectos = response.prospectos
        if (usuario !== null && usuario.listaProspectos !== undefined &&
          usuario.listaProspectos !== null) {
          listaProspectos = listaProspectos = listaProspectos.map(prospecto => {
            usuario.listaProspectos.map(prospectoEncontrado => {
              if (prospecto.idProspecto === prospectoEncontrado.idProspecto) {
                prospecto = prospectoEncontrado
              }
              return prospectoEncontrado
            })
            return prospecto
          })
        }

        setState((state) => {
          return {
            ...state,
            estaCargandoFaltante: false,
            listaProspectos: listaProspectos,
            estaCargandoProspectos: false,
            usuario: usuario
          }
        })
        await obtenerParametros()
        precargarProspecto(listaProspectos)
        return listaProspectos
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
        return response.prospectos
      }
    }

    const obtenerParametros = async () => {
      const response = await GeneralRepository.obtenerParametros()
      if(response.error === null) {
        generalDispatch(GeneralActions.setParametros(response.parametros))
        await obtenerEntidades()
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
      }
    }

    const obtenerEntidades = async () => {
      const response = await GeneralRepository.obtenerEntidadesFinancieras()
      if(response.error === null) {
        generalDispatch(GeneralActions.agregarTablaMaestra(61, 'Entidades', response.entidades))
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
      }
    }

    const precargarProspecto = (listaProspectos) => {
      let prospectoSeleccionado = null
      listaProspectos && listaProspectos.map(prospecto => {
        prospecto.tiempoFaltante = Funciones.obtenerMinutosFechaHoy(prospecto.fechaCita)
        if (Funciones.obtenerMinutosFechaHoy(prospecto.fechaCita) <= 5 &&
          Funciones.obtenerMinutosFechaHoy(prospecto.fechaCita) >= 0) {
          if (prospectoSeleccionado && prospectoSeleccionado.tiempoFaltante >= 0) {
            if (prospecto.tiempoFaltante < prospectoSeleccionado.tiempoFaltante) {
              prospectoSeleccionado = prospecto
            }
          } else {
            prospectoSeleccionado = prospecto
          }
        } else {
          if (Funciones.obtenerMinutosFechaHoy(prospecto.fechaCita) >= -60 &&
            Funciones.obtenerMinutosFechaHoy(prospecto.fechaCita) <= 0) {
            if (prospectoSeleccionado) {
              if (prospecto.tiempoFaltante > prospectoSeleccionado.tiempoFaltante) {
                prospectoSeleccionado = prospecto
              }
            } else {
              prospectoSeleccionado = prospecto
            }
          }
        }
        return prospecto
      })

      if (prospectoSeleccionado) {
        setState((state) => {
          return {
            ...state,
            nombre: prospectoSeleccionado.nombreCompleto,
            prospecto: prospectoSeleccionado,
            verProspectosSelected: false,
            errorSeleccionandoProspecto: false
          }
        })
        nombreRef.current.value = prospectoSeleccionado.nombreCompleto
      }
    }

    generalDispatch(GeneralActions.updateEstadoCargando(true))
    await obtenerDatosMaestros()
    generalDispatch(GeneralActions.updateEstadoCargando(false))
  }

  useEffect(() => {
    cargarDatosIniciales()
  }, [generalDispatch])

  return (
    <div>
      <Modal mostrarModal={mostrarModal} setModal={setModal} textos={textos} 
        estilos={{whiteSpace: "pre", textAlign: "justify", paddingLeft: "80px"}} />
      <HeaderHome usuario={state.usuario} />
      <section className={styles['areasearch']}>
        <div className={`${styles['areautosearch']} ${styles['area50']}`}>
          <h1>Bríndale a tu familia el futuro que merece</h1>
          <p>¿A quién vas a asesorar el día de hoy?</p>
          <span>Encuentra a tu Prospecto por nombres o apellidos</span>

          <form onSubmit={handleProspectoSubmit} className={styles['autocompletar']}>
            <input id="myInput" type="text"
              ref={nombreRef} onChange={state.listaProspectos !== null ? handleChange : undefined}
              disabled={state.estaCargandoProspectos}
              autoComplete="off"
              className={`${state.estaCargandoProspectos ? styles['loading'] : null} ${state.errorSeleccionandoProspecto ? styles['logerror'] : null}`}
              placeholder={state.estaCargandoProspectos ? '' : 'Buscar prospecto'} />
            {!state.estaCargandoProspectos && <button className={styles['lupa']} />}
            {state.errorSeleccionandoProspecto &&
              <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_PROSPECTO}</span>
            }
            <div id="myInputautocomplete-list" className={styles['autocomplete-items']}>
              {state.verProspectosSelected
                ? state.listaProspectosSelected.map((prospecto, index) => (
                  <div key={'prospecto_' + index} onClick={event => handleProspectoClick(prospecto)}>
                    {(prospecto.nombreCompleto).substring(0, prospecto.nombreCompleto.toUpperCase().indexOf(state.nombre.toUpperCase()))}
                    <strong>{(prospecto.nombreCompleto).substring(prospecto.nombreCompleto.toUpperCase().indexOf(state.nombre.toUpperCase()),
                      prospecto.nombreCompleto.toUpperCase().indexOf(state.nombre.toUpperCase()) + state.nombre.length)}</strong>
                    {(prospecto.nombreCompleto).substring(
                      prospecto.nombreCompleto.toUpperCase().indexOf(state.nombre.toUpperCase()) + state.nombre.length,
                      prospecto.nombreCompleto.length)} (IDProspecto: {prospecto.idProspecto})
                  </div>
                ))
                : ''}
            </div>
          </form>
        </div>

        <div className={styles['area50']}></div>
      </section>
    </div>
  );
};

export default Home